export default __webpack_public_path__ + "static/what-is-inTOUCH-d0c0408d5552223a2f2fe61d8736bd74.mp4";